import React, { useEffect, useRef } from 'react';

import { window } from '../src/env/browser';
import { useGlobals } from '@shared/contexts/GlobalsContext';

import useCreateAppConfig from './use-create-app-config';
import {
  containerStyle,
  iframeStyle,
  MICRO_APP_STARTUP_MESSAGE,
  MICRO_APP_URL,
} from './constants';

const APP_NAME = 'feedback';

export function FeedbackApp() {
  const deps = useGlobals();
  const iframeRef = useRef(null);
  const { isLoading, config } = useCreateAppConfig(APP_NAME, deps);

  useEffect(() => {
    if (iframeRef.current && !isLoading) {
      setTimeout(() => {
        window.Shore.microAppArgs[APP_NAME] = config;
        iframeRef.current.contentWindow.postMessage(
          { type: MICRO_APP_STARTUP_MESSAGE },
          '*'
        );
      }, 1000);
    }
  }, [iframeRef.current, isLoading]);

  return (
    <div style={containerStyle}>
      <iframe
        title="FeedbackApp"
        ref={iframeRef}
        style={iframeStyle}
        src={`${MICRO_APP_URL}/feedback`}
      />
    </div>
  );
}
